import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { toast } from "react-toastify";
import Logo from "../../../../../assets/img/logo.png";
import { useAuth } from "../../../../../contexts/AuthContext";
import useFetch from "../../../../../hooks/useFetch";
import usePersistentState from "../../../../../hooks/usePersistentState";
import SideNav from "../../../../shares/sideNav/SideNav";
import SideNavDrawer from "../../../../shares/sideNav/SideNavDrawer";
import { ADMIN_NAV, adminFooterNav } from "./navItems";

const EXPANDED = "w-[26rem]";
const COLLAPSED = "w-[7.2rem]";

// Hidden entirely while collapsed - scaling the logo down to fit a 7.2rem rail
// made it look squashed, and the toggle alone reads cleaner centred.
function Brand({ collapsed }) {
    if (collapsed) return null;

    return (
        <Link
            to="/"
            className="flex items-center rounded-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
            <img className="h-[4rem]" src={Logo} alt="عطار" />
        </Link>
    );
}

/** Signed-in teacher, pinned below the nav. */
function ProfileCard({ info, collapsed }) {
    const name = [info?.first_name, info?.last_name].filter(Boolean).join(" ");
    if (!name) return null;

    return (
        <div
            className={`flex items-center rounded-soft bg-surface-sunken py-sm ${
                collapsed ? "justify-center px-0" : "gap-sm px-sm"
            }`}
            title={name}
        >
            <AccountCircle sx={{ fontSize: "2.4rem" }} className="text-primary" />
            {!collapsed && (
                <span className="overflow-hidden text-ellipsis whitespace-nowrap text-base text-ink">
                    {name}
                </span>
            )}
        </div>
    );
}

function RightSidebar() {
    const [collapsed, setCollapsed] = usePersistentState(
        "attar.sidenav.collapsed",
        false
    );
    const [info, setInfo] = useState(null);
    const navigate = useNavigate();
    const { loginDispatch } = useAuth();

    useFetch({
        method: "GET",
        url: `student-panel/`,
        noHeader: false,
        trigger: true,
        setter: setInfo,
        errMessage: () =>
            toast.error("مشکلی در دریافت اطلاعات دانش آموز پیش آمده", {
                position: "bottom-left",
                rtl: true,
                autoClose: 2000,
            }),
    });

    const logoutFunc = () => {
        loginDispatch({ type: "LOGOUT" });
        navigate("/");
    };

    const footerItems = adminFooterNav(logoutFunc);

    return (
        <>
            {/* Fixed, not in flow - see the student sidebar for why. */}
            <div className="fixed start-sm top-sm z-40 md:hidden">
                <SideNavDrawer
                    items={ADMIN_NAV}
                    footerItems={footerItems}
                    ariaLabel="منوی مدیریت"
                    brand={<Brand collapsed={false} />}
                    footer={<ProfileCard info={info} collapsed={false} />}
                />
            </div>

            <aside
                aria-label="منوی مدیریت"
                className={`sticky top-0 hidden h-screen shrink-0 border-e border-rule-subtle bg-surface transition-[width] duration-200 motion-reduce:transition-none md:block ${
                    collapsed ? COLLAPSED : EXPANDED
                }`}
            >
                <SideNav
                    items={ADMIN_NAV}
                    footerItems={footerItems}
                    collapsed={collapsed}
                    onToggle={setCollapsed}
                    ariaLabel="منوی مدیریت"
                    brand={<Brand collapsed={collapsed} />}
                    footer={<ProfileCard info={info} collapsed={collapsed} />}
                />
            </aside>
        </>
    );
}

export default RightSidebar;
